import FormField from "../form-field";
import Api from "../../../../lib/api";
import {AnimationModule, EasingFunctions} from "../../../../lib/animation-module";

export default class CoachesField extends FormField {
	constructor(props) {
		super(props);

		this.$coachesListWrapper = null;
		this.$coachesList = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('CoachesField: Root element is not defined!');
		}

		this.$coachesListWrapper = this.$root.querySelector('.coaches-field_list-wrapper');
		this.$coachesList = this.$root.querySelector('.coaches-field_list');

		super.init();
	}

	fetchCoachesList(courseDirectoryId) {
		if (courseDirectoryId == null) return;

		const coachesListUrl = `${craft.env.apiSiteUrl}/feed/coachesField?course=${courseDirectoryId}`;

		if (this.value != null) {
			this.dropCheckboxes();
			this.setValue(null);
		}

		return Api.get(coachesListUrl)
			.then((data) => {
				data = data.trim();

				if (data) {
					this.$coachesList.innerHTML = data;

					this.validateSoft();
					this.refreshCoachesListHeight();
					this.addCoachesChooseEventListener();
				}
			})
			.catch((err) => {
				this.validateSoft();
				throw new Error('CoachesField: Fetch coaches list failed. ' + err);
			});
	}

	addCoachesChooseEventListener() {
		const $coachCheckboxes = this.$root.querySelectorAll('[type="checkbox"]');

		if (!$coachCheckboxes.length) return;

		$coachCheckboxes.forEach(($checkbox) => {
			$checkbox.addEventListener('change', (e) => {
				let data = [];

				$coachCheckboxes.forEach(($checkbox) => {
					if ($checkbox.checked) {
						data.push({
							name: $checkbox.dataset.name,
							value: $checkbox.value
						});
					}
				});

				this.setValue(data.length ? data : null);
				this.validateSoft();
			});
		});
	}

	validate() {
		if (this.value != null) {
			this.isValid = true;
		} else {
			this.isValid = false;

			if (this.$coachesList.innerHTML.length) {
				this.setError('coaches');
			} else {
				this.setError('course');
			}
		}
	}

	setInitialState() {
		this.$coachesList.innerHTML = '';
		this.setValue(null);
		this.validateSoft();
		this.setInitialHeight();
	}

	setInitialHeight() {
		const height = this.$coachesListWrapper.offsetHeight;

		AnimationModule.animate((progress) => {
			this.$coachesListWrapper.style.height = height * (1 - progress) + 'px';
		}, {
			timing: EasingFunctions.primary,
			duration: 200,
			complete: () => {
				this.$root.style.height = null;
				this.$coachesListWrapper.classList.remove('-scrollbar');
			}
		});
	}

	refreshCoachesListHeight(animate = true) {
		animate = animate ? animate : false;

		const oldHeight = this.$coachesListWrapper.offsetHeight;
		const newHeight = this.$coachesList.offsetHeight >= 400 ? 400: this.$coachesList.offsetHeight;

		if (newHeight >= 400) {
			this.$coachesListWrapper.classList.add('-scrollbar');
		} else {
			this.$coachesListWrapper.classList.remove('-scrollbar');
		}

		if (animate === false) {
			this.$coachesListWrapper.style.height = newHeight + 'px';
			return;
		}

		AnimationModule.animate((progress) => {
			this.$coachesListWrapper.style.height = oldHeight + (newHeight - oldHeight) * progress + 'px';
		}, {
			timing: EasingFunctions.primary,
			duration: 200
		});
	}

	dropCheckboxes() {
		const $coachCheckboxes = this.$root.querySelectorAll('[type="checkbox"]');

		if (!$coachCheckboxes.length) return;

		$coachCheckboxes.forEach(($checkbox) => {
			$checkbox.checked = false;
		});
	}

	setError(name) {
		if (name == null) {
			return;
		} else if (name === 'course') {
			this.$root.dataset.error = 'course';
		} else if (name === 'coaches') {
			this.$root.dataset.error = 'coaches';
		}
	}
}